import { Country } from '~/lib/api/smartsend/types';
import { IsInvariantStringMatch } from '../helpers/IsMatch';
export const CountryCache: { [key: string]: Country } = {};

export function FindCountryName(search: string) {
  const all = GetCachedCountries();
  if (all.find((a) => a.Name === search)) {
    return search;
  }

  const iso3Match = all.find((x) => IsInvariantStringMatch(x.CountryIsoCode, search) && !x.CountrySubdivision);
  if (iso3Match) {
    return iso3Match.Name;
  }

  const iso2Match = all.find((x) => IsInvariantStringMatch(x.CountryIso2Code, search) && !x.CountrySubdivision);
  if (iso2Match) {
    return iso2Match.Name;
  }

  return 'United Kingdom';
}

export function GetCachedCountries(): Country[] {
  return Object.values(CountryCache);
}

export function GenCountryKey(c: { CountryIsoCode: string; CountrySubdivision?: string }) {
  return `${c.CountryIsoCode}_${c.CountrySubdivision || ''}`;
}

export function GenCountryKeyForDeliveryCountries(c: { Iso3Code: string; Subdivision: string }) {
  return `${c.Iso3Code}_${c.Subdivision || ''}`;
}
